import { last, omit } from 'lodash';
import useHttpClient from 'hooks/useHttpClient';
import { useMutation } from '@tanstack/react-query';
import { awsS3ApiPath, awsS3PublicBucketName } from 'configs/variables';
import axios from 'axios';

export function useS3Upload(props = undefined) {
  const { post } = useHttpClient();

  const forceRequest = ({ _, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const mutation = useMutation({
    mutationFn: async (payload) => {
      const newPayload = {
        file_name: payload.file.name,
        file_extension: payload.fileExtension || last(payload.file.name.split('.')),
        module: payload.module,
        group: payload.group,
        bucket_name: awsS3PublicBucketName,
      };

      const fn = await post({ url: awsS3ApiPath + '/upload-public', payload: newPayload });

      return {
        ...fn,
        payload: {
          ...omit(payload, ['fileExtension']),
          ...newPayload,
        },
      };
    },
    async onSuccess(response) {
      if (response.statusCode !== 200) {
        props?.onError?.();
        return;
      }

      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      const url = response.body.url_upload;

      const formData = new FormData();

      const fields = omit(response.body.fields, 'Content-Type');

      try {
        Object.entries(fields).forEach((items) => {
          formData.append(items[0], items[1]);
        });

        const blobFile = await response.payload?.file?.arrayBuffer().then((res) => {
          const blobs = new Blob([res]);
          return blobs;
        });

        formData.append('file', blobFile, response.payload?.fileName);

        return await axios({
          method: 'post',
          headers,
          url,
          data: formData,
          onUploadProgress: (event) => {
            if (!event.total) {
              return;
            }

            const percent = Math.round((event.loaded / event.total) * 100);
            response.payload?.onProgress?.(percent);
            props?.onProgress?.(percent, response.payload?.uid);
          },
        }).then(() => {
          const resp = {
            url: response.body?.public_url,
            file_name: response.body?.file_name,
            fileExtension: response.payload?.file_extension,
            uid: response.payload?.uid,
          };

          props?.onSuccess?.(resp);
        });
      } catch (error) {
        console.debug('use-s3-upload.js line 79:', error);
        props?.onError?.();
      }
    },
    onError(error) {
      console.debug('use-s3-upload.js line 84:', error);
      props?.onError?.();
    },
  });

  return {
    ...mutation,
    forceRequest,
  };
}
